import React from "react";
import IntlMessages from "@util/IntlMessages";
import InformationListDataSettings from "./InformationListDataSettings";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const InformationListModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="3">
            <InformationListDataSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default InformationListModal;
